import { Pipe, PipeTransform } from '@angular/core';

import { formatVatRate } from '../helpers';

@Pipe({name: 'vatRateFormat'})
export class VatRateFormatPipe implements PipeTransform {
  transform(value: number | string): string {
    return formatVatRate(value);
  }
}
